import * as types from 'features/invoices/invoiceActions';
import { REHYDRATE } from 'redux-persist';

let defaultState = {
    error: null,
    isLoading: false,
    loaded: false,
    invoices: []
};

export default function companyInvoices(state = defaultState, action) {
    switch (action.type) {
        case types.REQUEST_COMPANY_INVOICES_START:
            return {
                ...state,
                error: null,
                loaded: false,
                isLoading: true
            };

        case types.REQUEST_COMPANY_INVOICES_COMPLETED:
            var invoices = action.payload?.invoices || [];
            return {
                ...state,
                error: null,
                loaded: true,
                isLoading: false,
                invoices: invoices
            };

        case types.REQUEST_COMPANY_INVOICES_ERROR:
            return {
                ...state,
                error: action.error,
                loaded: false,
                isLoading: false
            };

        case REHYDRATE:
            return {
                ...state
            };

        default:
            return state;
    }
}
